import { LOGIN } from 'actions/Types';

export default function signedUp(state = false, action) {
  if (action.type === `${LOGIN}_SUCCESS`) {
    return true;
  }

  return state;
}
